import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './trpc.js';

export const TrpcProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
}; 